import React, {useEffect} from "react"
import {useFormik} from "formik";
import * as yup from "yup";

import GeoService from "../../../services/geo";
import CountryFlag from "../../../components/CountryFlag";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {createFilterOptions} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";

const languages = [
    {value: "IT", label: "Italiano"},
    {value: "EN", label: "Inglese"}
]

export const getNationalityLanguage = (nationality) => {
    return nationality === "IT" ? "IT" : "EN";
}

export const useStepGuest = ({surname, name, email, nationality, language, onSubmit=f=>f}) => {
    const formik = useFormik({
            initialValues: {
                surname: surname || "",
                name: name || "",
                email: email || "",
                nationality:  nationality || "",
                language: language || ""
            },
            validationSchema: yup.object().shape({
                name: yup
                    .string()
                    .typeError('Deve essere in formato testuale')
                    .required('Campo obbligatorio'),
                surname: yup
                    .string()
                    .typeError('Deve essere in formato testuale')
                    .required('Campo obbligatorio'),
                email: yup
                    .string()
                    .email('Deve essere un indirizzo email valido'),
                nationality: yup
                    .string()
                    .nullable(true)
                    .typeError('Campo non valido')
                    .required('Campo obbligatorio'),
                language: yup
                    .string()
                    .oneOf(['IT', 'EN'], "Deve essere o Italiano o Inglese")
                    .nullable(true)
                    .typeError('Campo non valido')
                    .required('Campo obbligatorio')
            }),
            onSubmit: (values) => onSubmit(values),
        }
    );

    return {formik};
}

const StepGuest = ({formik}) => {

    // TODO from now on it is exactly equal to the booking guest step
    const filterOptions = createFilterOptions({
        matchFrom: 'start'
    });

    useEffect(
        () => {
            if(formik.values.language === "" && formik.values.nationality !== ""){
                formik.setFieldValue("language", getNationalityLanguage(formik.values.nationality));
            }
        },
        [formik.values.nationality]  // eslint-disable-line react-hooks/exhaustive-deps
    )
    return <>
        <Typography variant='h6' color='primary' fontWeight="normal" sx={{mb: 2}}>
            Anagrafica ospite
        </Typography>

        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <TextField label="Cognome"
                           fullWidth
                           name="surname"
                           required
                           value={formik.values.surname}
                           onChange={formik.handleChange}
                           error={formik.touched.surname && Boolean(formik.errors.surname)}
                           helperText={formik.touched.surname && formik.errors.surname}/>
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField label="Nome"
                           fullWidth
                           name="name"
                           required
                           value={formik.values.name}
                           onChange={formik.handleChange}
                           error={formik.touched.name && Boolean(formik.errors.name)}
                           helperText={formik.touched.name && formik.errors.name}/>
            </Grid>

            <Grid item xs={12}>
                <TextField label="Email"
                           fullWidth
                           name="email"
                           required
                           value={formik.values.email}
                           onChange={formik.handleChange}
                           error={formik.touched.email && Boolean(formik.errors.email)}
                           helperText={formik.touched.email && formik.errors.email}/>
            </Grid>

            <Grid item xs={12} md={6}>
                <Autocomplete
                    options={GeoService.COUNTRIES}
                    filterOptions={filterOptions}
                    autoHighlight
                    getOptionLabel={(option) => option.label}
                    value={GeoService.COUNTRIES.find(c => c.code === formik.values.nationality) || null}
                    onChange={(event, value) => {
                        formik.setFieldValue("nationality", value ? value.code : null)
                    }}
                    renderOption={(props, option) => (
                        <Box component="li"
                             sx={{fontSize: 15, '& > img': {mr: 1}}}
                             {...props}>
                            <CountryFlag code={option.code}/>
                            {option.label}
                        </Box>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Nazionalità"
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            }}
                            fullWidth
                            required
                            error={formik.touched.nationality && Boolean(formik.errors.nationality)}
                            helperText={formik.touched.nationality && formik.errors.nationality}/>
                    )}/>
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField
                    select
                    label="Lingua preventivo"
                    fullWidth
                    name="language"
                    required
                    value={formik.values.language}
                    onChange={formik.handleChange}
                    error={formik.touched.language && Boolean(formik.errors.language)}
                    helperText={formik.touched.language && formik.errors.language}>
                    {
                        languages.map(option =>
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        )
                    }
                </TextField>
            </Grid>
        </Grid>
    </>
}

export default StepGuest;